import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";

import { AuthenticationService } from "../services/auth.service";
import { AuthfakeauthenticationService } from "../services/authfake.service";
import { environment } from "../../../environments/environment";
import { LocalStorageService } from "../services/local-storage.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	constructor(
		private authenticationService: AuthenticationService,
		private authfackservice: AuthfakeauthenticationService,
		private localstorage: LocalStorageService
	) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Skip JWT for OpenAI API calls
		if (request.url.includes('api.openai.com')) {
			return next.handle(request); // Do not add JWT
		}

		if (environment.defaultauth === "firebase") {
			// Firebase logic (commented out in your code)
		} else {
			// Normal JWT logic for other requests
			const currentUser = this.authenticationService.currentUserValue;
			const token = this.localstorage.get("token");

			if (currentUser && token) {
				request = request.clone({
					setHeaders: {
						Authorization: `Bearer ${token}`,
					},
				});
			}
		}
		return next.handle(request);
	}
}